module.exports = __webpack_public_path__ + "img/toyota02.96a85b8c.png";